import styled from '@emotion/styled';
import theme from '@ep/theme';
import { Gcms_Asset } from '@ep/types/gatsbyTypes';
import React from 'react';

export interface BackgroundProps {
  url?: string;
  altText?: string;
}

const Background = styled.div`
  position: relative;
`;

const BackgroundImage = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  width: 100%;
  max-width: ${theme.breakpoints.maximumDesktop}px;
  ${({fromHeroFeaturesModuleProps}: {fromHeroFeaturesModuleProps: boolean})=>(fromHeroFeaturesModuleProps? 'height: 110%' : 'height: 100%')};
  transform: translateX(-50%);
  background-size: cover;
  background-position: center;
`;

const VideoContainer = styled.div`
  position: absolute;
  z-index: 0;
  top: 0;
  left: 50%;
  overflow: hidden;
  display: block;
  width: 100%;
  max-width: 1920px;
  height: 100%;
  transform: translateX(-50%);
`;

const StyledVideo = styled.video`
  position: absolute;
  z-index: 0;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  ${theme.mediaQueries.desktop} {
    width: 100%;
  }
`;

interface StyledContainerProps {
  fromCarousel?: boolean;
}

const StyledContainer = styled.div<StyledContainerProps>`
  position: relative;
  margin: 0 auto;
  max-width: 1110px;

  @media (max-width: 1174px) {
    ${({ fromCarousel }) => `
      ${fromCarousel ? 'padding' : 'margin'}: 0 2rem;
    `}
  }

  ${theme.mediaQueries.mobile} {
    ${({ fromCarousel }) => `
    ${fromCarousel ? 'padding' : 'margin'}: 0 1rem;
    `}
  }
`;

export interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  backgroundColor?: string;
  backgroundColors?: string[];
  background?: Gcms_Asset;
  fromCarousel?: boolean;
  videoPositionLeft?: boolean;
  fromHeroFeaturesModule?: boolean;
}

function Container({
  backgroundColor,
  backgroundColors,
  background,
  fromCarousel,
  fromHeroFeaturesModule,
  ...rest
}: ContainerProps) {
  const style: React.CSSProperties = {};

  if (backgroundColor) {
    style.backgroundColor = backgroundColor;
  } else if (backgroundColors) {
    const colors = backgroundColors.join(', ');
    style.background = `linear-gradient(90deg, ${colors})`;
  } else if (background) {
    style.backgroundColor = theme.colors.darkBlue;
  }

  if (fromCarousel) {
    style.minWidth = '100%';
  }
  
  return (
    <Background style={style}>
      {background &&
        (background.vidyardLink === 'background-video-mp4' ||
        background.vidyardLink === 'video' ? (
          <VideoContainer>
            <StyledVideo autoPlay muted>
              <source src={`${background.url}`} />
            </StyledVideo>
          </VideoContainer>
        ) : (
          <BackgroundImage
            style={{ backgroundImage: `url(${background.url})` }}
            aria-label={background.altText ? background.altText : 'Hero Image'}
            role="img"
            fromHeroFeaturesModuleProps={fromHeroFeaturesModule}
          />
        ))}
      <StyledContainer fromCarousel={fromCarousel} {...rest} />
    </Background>
  );
}

export default React.memo(Container);
